// tslint:disable
/* MACLE TypeScript 10/01/2026 17:44:39 */
import { ArrayList } from 'maf-web';

export abstract class BaseVO {
  readonly jclass: string = "com.sollus.vo.BaseVO";
}


export abstract class BaseData extends BaseVO {
  readonly jclass: string = "com.sollus.vo.BaseData";
}


export class DataEndereco extends BaseData {
  readonly jclass: string = "com.sollus.vo.DataEndereco";
  complemento: string = "";
  endereco: string = "";
  bairro: string = "";
  cidade: string = "";
  codCEP: number = 0;
  codUF: string = "";
  codPais: number = 0;
  numero: string = "";
}


export class DataEnderecoComp extends DataEndereco {
  readonly jclass: string = "com.sollus.vo.DataEnderecoComp";
  infReferencia: string = "";
  retirarLoja: boolean = false;
  descricaoEndereco: string = "";
}


export class BaseDataDisplay extends BaseData {
  readonly jclass: string = "com.sollus.vo.BaseDataDisplay";
  value: string = "";
  display: string = "";
}


export enum EFaixaEtaria {
  NONE = 0,
  ADULTO = 1,
  INFANTIL = 2,
  BB = 3,
}

export namespace EFaixaEtaria {
  export function toDisplay(arg: EFaixaEtaria): string {
    switch (arg) {
      case 0: return "";
      case 1: return "Adulto";
      case 2: return "Infantil";
      case 3: return "Bebe";
      default: return "";
    }
  }

  export function enums(): EFaixaEtaria[] {
    return [EFaixaEtaria.NONE,EFaixaEtaria.ADULTO,EFaixaEtaria.INFANTIL,EFaixaEtaria.BB];
  }
}


export enum ETipoPagtoSite {
  NONE = 0,
  PAGSYS = 1,
  PAGSEGURO = 2,
  CIELO = 3,
  ITAU = 4,
  REDECARD = 5,
  MOOVIN = 6,
  PAGAR_ME = 7,
  CREDIARIO = 8,
  CONDICIONAL = 9,
  INTEGRACAO_WS = 10,
  LOJA = 11,
  MARKETPLACE = 12,
  SITEF = 13,
  ZOOP = 14,
  MACLE_PAGTO = 15,
}

export namespace ETipoPagtoSite {
  export function toDisplay(arg: ETipoPagtoSite): string {
    switch (arg) {
      case 0: return "";
      case 1: return "Pagsys";
      case 2: return "Pag Seguro";
      case 3: return "Cielo";
      case 4: return "Itau";
      case 5: return "Redecard";
      case 6: return "Moovin";
      case 7: return "Pagar.me";
      case 8: return "Credi&aacute;rio";
      case 9: return "Condicional";
      case 10: return "Integra&ccedil;&atilde;o WS";
      case 11: return "Loja";
      case 12: return "Marketplace";
      case 13: return "SiTEF";
      case 14: return "ZOOP";
      case 15: return "MACLE Pagto";
      default: return "";
    }
  }

  export function enums(): ETipoPagtoSite[] {
    return [ETipoPagtoSite.NONE,ETipoPagtoSite.PAGSYS,ETipoPagtoSite.PAGSEGURO,ETipoPagtoSite.CIELO,ETipoPagtoSite.ITAU,ETipoPagtoSite.REDECARD,ETipoPagtoSite.MOOVIN,ETipoPagtoSite.PAGAR_ME,ETipoPagtoSite.CREDIARIO,ETipoPagtoSite.CONDICIONAL,ETipoPagtoSite.INTEGRACAO_WS,ETipoPagtoSite.LOJA,ETipoPagtoSite.MARKETPLACE,ETipoPagtoSite.SITEF,ETipoPagtoSite.ZOOP,ETipoPagtoSite.MACLE_PAGTO];
  }
}


export enum ERamoAtividade {
  NONE = 0,
  CALCADO_CONFECCAO = 1,
  ELETRO_MOVEIS = 2,
  OTICA = 3,
}

export namespace ERamoAtividade {
  export function toDisplay(arg: ERamoAtividade): string {
    switch (arg) {
      case 0: return "";
      case 1: return "Cal&ccedil;ado Confec&ccedil;&atilde;o";
      case 2: return "El&eacute;tro M&oacute;veis";
      case 3: return "&Oacute;tica";
      default: return "";
    }
  }

  export function enums(): ERamoAtividade[] {
    return [ERamoAtividade.NONE,ERamoAtividade.CALCADO_CONFECCAO,ERamoAtividade.ELETRO_MOVEIS,ERamoAtividade.OTICA];
  }
}


export enum ESexo {
  NONE = "NULL",
  MASCULINO = "'M'",
  FEMININO = "'F'",
}

export namespace ESexo {
  export function toDisplay(arg: ESexo): string {
    switch (arg) {
      case "NULL": return "";
      case "'M'": return "Masculino";
      case "'F'": return "Feminino";
      default: return "";
    }
  }

  export function enums(): ESexo[] {
    return [ESexo.NONE,ESexo.MASCULINO,ESexo.FEMININO];
  }
}


export enum EArredondPrc {
  NONE = 0,
  ZERO = 1,
  CINQUENTA = 2,
  OITENTA = 3,
  OITO_NOVE = 9,
  NOVENTA = 4,
  NOV_CINCO = 7,
  NOV_OITO = 8,
  NOV_NOVE = 5,
  DEC_CENTAVOS = 6,
}

export namespace EArredondPrc {
  export function toDisplay(arg: EArredondPrc): string {
    switch (arg) {
      case 0: return "Nenhum";
      case 1: return "*,00";
      case 2: return "*,50";
      case 3: return "*,80";
      case 9: return "*,89";
      case 4: return "*,90";
      case 7: return "*,95";
      case 8: return "*,98";
      case 5: return "*,99";
      case 6: return "*,*0";
      default: return "";
    }
  }

  export function enums(): EArredondPrc[] {
    return [EArredondPrc.NONE,EArredondPrc.ZERO,EArredondPrc.CINQUENTA,EArredondPrc.OITENTA,EArredondPrc.OITO_NOVE,EArredondPrc.NOVENTA,EArredondPrc.NOV_CINCO,EArredondPrc.NOV_OITO,EArredondPrc.NOV_NOVE,EArredondPrc.DEC_CENTAVOS];
  }
}


export class BaseDataParamSistema extends BaseData {
  readonly jclass: string = "com.sollus.vo.BaseDataParamSistema";
  idBase: number = 0;
  versaoBase: number = 0;
  appBasePath: string = "";
  imgContextName: string = "";
  appImgPath: string = "";
  numRecInPage: number = 0;
}


export enum EBancoFebraban {
  NONE = 0,
  BANCO_DO_BRASIL = 1,
  BANCO_DA_AMAZONIA = 2,
  BANCO_DO_NORDESTE = 3,
  BANESTES = 4,
  BANRISUL = 5,
  BANCO_BRB = 6,
  CAIXA_ECONOMICA_FEDERAL = 7,
  BANCO_BRADESCO = 8,
  ITAU_UNIBANCO = 9,
  BANCO_MERCANTIL_DO_BRASIL = 10,
  BANCO_SAFRA = 11,
  BANCO_RURAL = 12,
  BANCO_RENDIMENTO = 13,
  BANCO_SANTANDER = 14,
  BANCO_CITIBANK = 15,
  BANCO_ORIGINAL = 16,
  BANCO_INTER = 17,
  BANCO_VOTORANTIM = 18,
  BANCO_DAYCOVAL = 19,
  BANCO_BMG = 20,
  BANCO_PAN = 21,
  BANCO_COOPERATIVO_SICREDI = 22,
  BANCO_COOPERATIVO_SICOOB = 23,
  BANCO_C6 = 24,
  BANCO_BS2 = 25,
  BANCO_MODAL = 26,
  BANCO_NEON = 27,
  NUBANK = 28,
  BANCO_XP = 29,
  BANCO_BTG_PACTUAL = 30,
  BANCO_SOFISA = 31,
  BANCO_TOPAZIO = 32,
  BANCO_FIBRA = 33,
  BANCO_ABC_BRASIL = 34,
  BANCO_ALFA = 35,
  BANCO_ANDBANK = 36,
  BANCO_ARBI = 37,
  BANCO_BANIF = 38,
  BANCO_BBM = 39,
  BANCO_BIC = 40,
  BANCO_BMF = 41,
  BANCO_BNP_PARIBAS = 42,
  BANCO_BOAVISTA = 43,
  BANCO_BONSUCESSO = 44,
  BANCO_BRACCE = 45,
  BANCO_CACIQUE = 46,
  BANCO_CAPITAL = 47,
  BANCO_CARGILL = 48,
  BANCO_CEDULA = 49,
  BANCO_CETELEM = 50,
  BANCO_CLASSICO = 51,
  BANCO_CONFIDENCE = 52,
  BANCO_CREFISA = 53,
  BANCO_CREDIT_AGRICOLE = 54,
  BANCO_CREDIT_SUISSE = 55,
  BANCO_CRUZEIRO_DO_SUL = 56,
  BANCO_CSF = 57,
  BANCO_DEUTSCHE_BANK = 58,
  BANCO_DIBENS = 59,
  BANCO_FATOR = 60,
  BANCO_FICSA = 61,
  BANCO_FIDIS = 62,
  BANCO_FINASA = 63,
  BANCO_FORD = 64,
  BANCO_GE_CAPITAL = 65,
  BANCO_GERDAU = 66,
  BANCO_GMAC = 67,
  BANCO_GUANABARA = 68,
  BANCO_HONDA = 69,
  BANCO_HSBC = 70,
  BANCO_IBI = 71,
  BANCO_IBM = 72,
  BANCO_INDUSTRIAL_DO_BRASIL = 73,
  BANCO_INDUSVAL = 74,
  BANCO_ING = 75,
  BANCO_INVESTCRED = 76,
  BANCO_ITAU_BBA = 77,
  BANCO_ITAUCARD = 78,
  BANCO_JOHN_DEERE = 79,
  BANCO_JP_MORGAN_CHASE = 80,
  BANCO_KDB_BRASIL = 81,
  BANCO_KEB_BRASIL = 82,
  BANCO_LUSO_BRASILEIRO = 83,
  BANCO_MATONE = 84,
  BANCO_MAXIMA = 85,
  BANCO_MAXINVEST = 86,
  BANCO_MERCEDES_BENZ = 87,
  BANCO_MIZUHO = 88,
  BANCO_MORGAN_STANLEY = 89,
  BANCO_OURINVEST = 90,
  BANCO_PAULISTA = 91,
  BANCO_PECUNIA = 92,
  BANCO_PETRA = 93,
  BANCO_PINE = 94,
  BANCO_POTTENCIAL = 95,
  BANCO_PSA_FINANCE = 96,
  BANCO_RABOBANK = 97,
  BANCO_RANDON = 98,
  BANCO_RIBEIRAO_PRETO = 99,
  BANCO_RODOBENS = 100,
  BANCO_SCHAHIN = 101,
  BANCO_SEMEAR = 102,
  BANCO_SOCIETE_GENERALE = 103,
  BANCO_SUMITOMO_MITSUI = 104,
  BANCO_TOYOTA = 105,
  BANCO_TRIANGULO = 106,
  BANCO_VOLKSWAGEN = 107,
  BANCO_VOLVO = 108,
  BANCO_VR = 109,
  BANCO_WESTERN_UNION = 110,
  BANCO_WOORI = 111,
  BANCO_ZOGBI = 112,
}

export namespace EBancoFebraban {
  export function toDisplay(arg: EBancoFebraban): string {
    switch (arg) {
      case 0: return "";
      case 1: return "Banco do Brasil S.A.";
      case 2: return "Banco da Amazônia S.A.";
      case 3: return "Banco do Nordeste do Brasil S.A.";
      case 4: return "Banestes S.A. Banco do Estado do Esp&iacute;rito Santo";
      case 5: return "Banco do Estado do Rio Grande do Sul S.A.";
      case 6: return "Banco de Bras&iacute;lia S.A.";
      case 7: return "Caixa Econômica Federal";
      case 8: return "Banco Bradesco S.A.";
      case 9: return "Ita&uacute; Unibanco S.A.";
      case 10: return "Banco Mercantil do Brasil S.A.";
      case 11: return "Banco Safra S.A.";
      case 12: return "Banco Rural S.A.";
      case 13: return "Banco Rendimento S.A.";
      case 14: return "Banco Santander (Brasil) S.A.";
      case 15: return "Banco Citibank S.A.";
      case 16: return "Banco Original S.A.";
      case 17: return "Banco Inter S.A.";
      case 18: return "Banco Votorantim S.A.";
      case 19: return "Banco Daycoval S.A.";
      case 20: return "Banco BMG S.A.";
      case 21: return "Banco Pan S.A.";
      case 22: return "Banco Cooperativo Sicredi S.A.";
      case 23: return "Banco Cooperativo Sicoob S.A.";
      case 24: return "Banco C6 S.A.";
      case 25: return "Banco BS2 S.A.";
      case 26: return "Banco Modal S.A.";
      case 27: return "Banco Neon S.A.";
      case 28: return "Nu Pagamentos S.A.";
      case 29: return "Banco XP S.A.";
      case 30: return "Banco BTG Pactual S.A.";
      case 31: return "Banco Sofisa S.A.";
      case 32: return "Banco Top&aacute;zio S.A.";
      case 33: return "Banco Fibra S.A.";
      case 34: return "Banco ABC Brasil S.A.";
      case 35: return "Banco Alfa S.A.";
      case 36: return "Banco Andbank (Brasil) S.A.";
      case 37: return "Banco Arbi S.A.";
      case 38: return "Banco Banif Brasil S.A.";
      case 39: return "Banco BBM S.A.";
      case 40: return "Banco Industrial e Comercial S.A.";
      case 41: return "Banco BM&amp;F de Servi&ccedil;os de Liquida&ccedil;&atilde;o e Cust&oacute;dia S.A.";
      case 42: return "Banco BNP Paribas Brasil S.A.";
      case 43: return "Banco Boavista Interatl&acirc;ntico S.A.";
      case 44: return "Banco Bonsucesso S.A.";
      case 45: return "Banco Bracce S.A.";
      case 46: return "Banco Cacique S.A.";
      case 47: return "Banco Capital S.A.";
      case 48: return "Banco Cargill S.A.";
      case 49: return "Banco C&eacute;dula S.A.";
      case 50: return "Banco Cetelem S.A.";
      case 51: return "Banco Cl&aacute;ssico S.A.";
      case 52: return "Banco Confidence de C&acirc;mbio S.A.";
      case 53: return "Banco Crefisa S.A.";
      case 54: return "Banco Credit Agricole Brasil S.A.";
      case 55: return "Banco Credit Suisse (Brasil) S.A.";
      case 56: return "Banco Cruzeiro do Sul S.A.";
      case 57: return "Banco CSF S.A.";
      case 58: return "Deutsche Bank S.A. - Banco Alem&atilde;o";
      case 59: return "Banco Dibens S.A.";
      case 60: return "Banco Fator S.A.";
      case 61: return "Banco Ficsa S.A.";
      case 62: return "Banco Fidis S.A.";
      case 63: return "Banco Finasa S.A.";
      case 64: return "Banco Ford S.A.";
      case 65: return "Banco GE Capital S.A.";
      case 66: return "Banco Gerdau S.A.";
      case 67: return "Banco GMAC S.A.";
      case 68: return "Banco Guanabara S.A.";
      case 69: return "Banco Honda S.A.";
      case 70: return "HSBC Bank Brasil S.A. - Banco M&uacute;ltiplo";
      case 71: return "Banco Ibi S.A. Banco M&uacute;ltiplo";
      case 72: return "Banco IBM S.A.";
      case 73: return "Banco Industrial do Brasil S.A.";
      case 74: return "Banco Indusval S.A.";
      case 75: return "ING Bank N.V.";
      case 76: return "Banco Investcred Unibanco S.A.";
      case 77: return "Ita&uacute; BBA S.A.";
      case 78: return "Itaucard S.A.";
      case 79: return "Banco John Deere S.A.";
      case 80: return "JP Morgan Chase Bank";
      case 81: return "Banco KDB do Brasil S.A.";
      case 82: return "Banco KEB do Brasil S.A.";
      case 83: return "Banco Luso Brasileiro S.A.";
      case 84: return "Banco Matone S.A.";
      case 85: return "Banco M&aacute;xima S.A.";
      case 86: return "Banco Maxinvest S.A.";
      case 87: return "Banco Mercedes-Benz do Brasil S.A.";
      case 88: return "Banco Mizuho do Brasil S.A.";
      case 89: return "Banco Morgan Stanley S.A.";
      case 90: return "Banco Ourinvest S.A.";
      case 91: return "Banco Paulista S.A.";
      case 92: return "Banco Pec&uacute;nia S.A.";
      case 93: return "Banco Petra S.A.";
      case 94: return "Banco Pine S.A.";
      case 95: return "Banco Pottencial S.A.";
      case 96: return "Banco PSA Finance Brasil S.A.";
      case 97: return "Banco Rabobank International Brasil S.A.";
      case 98: return "Banco Randon S.A.";
      case 99: return "Banco Ribeir&atilde;o Preto S.A.";
      case 100: return "Banco Rodobens S.A.";
      case 101: return "Banco Schahin S.A.";
      case 102: return "Banco Semear S.A.";
      case 103: return "Banco Soci&eacute;t&eacute; G&eacute;n&eacute;rale Brasil S.A.";
      case 104: return "Banco Sumitomo Mitsui Brasileiro S.A.";
      case 105: return "Banco Toyota do Brasil S.A.";
      case 106: return "Banco Tri&acirc;ngulo S.A.";
      case 107: return "Banco Volkswagen S.A.";
      case 108: return "Banco Volvo (Brasil) S.A.";
      case 109: return "Banco VR S.A.";
      case 110: return "Banco Western Union do Brasil S.A.";
      case 111: return "Banco Woori Bank do Brasil S.A.";
      case 112: return "Banco Zogbi S.A.";
      default: return "";
    }
  }

  export function enums(): EBancoFebraban[] {
    return [EBancoFebraban.NONE,EBancoFebraban.BANCO_DO_BRASIL,EBancoFebraban.BANCO_DA_AMAZONIA,EBancoFebraban.BANCO_DO_NORDESTE,EBancoFebraban.BANESTES,EBancoFebraban.BANRISUL,EBancoFebraban.BANCO_BRB,EBancoFebraban.CAIXA_ECONOMICA_FEDERAL,EBancoFebraban.BANCO_BRADESCO,EBancoFebraban.ITAU_UNIBANCO,EBancoFebraban.BANCO_MERCANTIL_DO_BRASIL,EBancoFebraban.BANCO_SAFRA,EBancoFebraban.BANCO_RURAL,EBancoFebraban.BANCO_RENDIMENTO,EBancoFebraban.BANCO_SANTANDER,EBancoFebraban.BANCO_CITIBANK,EBancoFebraban.BANCO_ORIGINAL,EBancoFebraban.BANCO_INTER,EBancoFebraban.BANCO_VOTORANTIM,EBancoFebraban.BANCO_DAYCOVAL,EBancoFebraban.BANCO_BMG,EBancoFebraban.BANCO_PAN,EBancoFebraban.BANCO_COOPERATIVO_SICREDI,EBancoFebraban.BANCO_COOPERATIVO_SICOOB,EBancoFebraban.BANCO_C6,EBancoFebraban.BANCO_BS2,EBancoFebraban.BANCO_MODAL,EBancoFebraban.BANCO_NEON,EBancoFebraban.NUBANK,EBancoFebraban.BANCO_XP,EBancoFebraban.BANCO_BTG_PACTUAL,EBancoFebraban.BANCO_SOFISA,EBancoFebraban.BANCO_TOPAZIO,EBancoFebraban.BANCO_FIBRA,EBancoFebraban.BANCO_ABC_BRASIL,EBancoFebraban.BANCO_ALFA,EBancoFebraban.BANCO_ANDBANK,EBancoFebraban.BANCO_ARBI,EBancoFebraban.BANCO_BANIF,EBancoFebraban.BANCO_BBM,EBancoFebraban.BANCO_BIC,EBancoFebraban.BANCO_BMF,EBancoFebraban.BANCO_BNP_PARIBAS,EBancoFebraban.BANCO_BOAVISTA,EBancoFebraban.BANCO_BONSUCESSO,EBancoFebraban.BANCO_BRACCE,EBancoFebraban.BANCO_CACIQUE,EBancoFebraban.BANCO_CAPITAL,EBancoFebraban.BANCO_CARGILL,EBancoFebraban.BANCO_CEDULA,EBancoFebraban.BANCO_CETELEM,EBancoFebraban.BANCO_CLASSICO,EBancoFebraban.BANCO_CONFIDENCE,EBancoFebraban.BANCO_CREFISA,EBancoFebraban.BANCO_CREDIT_AGRICOLE,EBancoFebraban.BANCO_CREDIT_SUISSE,EBancoFebraban.BANCO_CRUZEIRO_DO_SUL,EBancoFebraban.BANCO_CSF,EBancoFebraban.BANCO_DEUTSCHE_BANK,EBancoFebraban.BANCO_DIBENS,EBancoFebraban.BANCO_FATOR,EBancoFebraban.BANCO_FICSA,EBancoFebraban.BANCO_FIDIS,EBancoFebraban.BANCO_FINASA,EBancoFebraban.BANCO_FORD,EBancoFebraban.BANCO_GE_CAPITAL,EBancoFebraban.BANCO_GERDAU,EBancoFebraban.BANCO_GMAC,EBancoFebraban.BANCO_GUANABARA,EBancoFebraban.BANCO_HONDA,EBancoFebraban.BANCO_HSBC,EBancoFebraban.BANCO_IBI,EBancoFebraban.BANCO_IBM,EBancoFebraban.BANCO_INDUSTRIAL_DO_BRASIL,EBancoFebraban.BANCO_INDUSVAL,EBancoFebraban.BANCO_ING,EBancoFebraban.BANCO_INVESTCRED,EBancoFebraban.BANCO_ITAU_BBA,EBancoFebraban.BANCO_ITAUCARD,EBancoFebraban.BANCO_JOHN_DEERE,EBancoFebraban.BANCO_JP_MORGAN_CHASE,EBancoFebraban.BANCO_KDB_BRASIL,EBancoFebraban.BANCO_KEB_BRASIL,EBancoFebraban.BANCO_LUSO_BRASILEIRO,EBancoFebraban.BANCO_MATONE,EBancoFebraban.BANCO_MAXIMA,EBancoFebraban.BANCO_MAXINVEST,EBancoFebraban.BANCO_MERCEDES_BENZ,EBancoFebraban.BANCO_MIZUHO,EBancoFebraban.BANCO_MORGAN_STANLEY,EBancoFebraban.BANCO_OURINVEST,EBancoFebraban.BANCO_PAULISTA,EBancoFebraban.BANCO_PECUNIA,EBancoFebraban.BANCO_PETRA,EBancoFebraban.BANCO_PINE,EBancoFebraban.BANCO_POTTENCIAL,EBancoFebraban.BANCO_PSA_FINANCE,EBancoFebraban.BANCO_RABOBANK,EBancoFebraban.BANCO_RANDON,EBancoFebraban.BANCO_RIBEIRAO_PRETO,EBancoFebraban.BANCO_RODOBENS,EBancoFebraban.BANCO_SCHAHIN,EBancoFebraban.BANCO_SEMEAR,EBancoFebraban.BANCO_SOCIETE_GENERALE,EBancoFebraban.BANCO_SUMITOMO_MITSUI,EBancoFebraban.BANCO_TOYOTA,EBancoFebraban.BANCO_TRIANGULO,EBancoFebraban.BANCO_VOLKSWAGEN,EBancoFebraban.BANCO_VOLVO,EBancoFebraban.BANCO_VR,EBancoFebraban.BANCO_WESTERN_UNION,EBancoFebraban.BANCO_WOORI,EBancoFebraban.BANCO_ZOGBI];
  }
}


export enum ETipoCST51SPED {
  REDUCAO_BASE = 0,
  NORMAL = 1,
}

export namespace ETipoCST51SPED {
  export function toDisplay(arg: ETipoCST51SPED): string {
    switch (arg) {
      case 0: return "Informar o diferimento com base de calculo reduzida e CST 51";
      case 1: return "Informar o diferimento com a base de calculo cheia e CST 00";
      default: return "";
    }
  }

  export function enums(): ETipoCST51SPED[] {
    return [ETipoCST51SPED.REDUCAO_BASE,ETipoCST51SPED.NORMAL];
  }
}


export enum ETipoVendaNFe {
  NONE = 0,
  PRESENCIAL = 1,
  INTERNET = 2,
  OUTROS = 3,
  NFC_DELIVERY = 4,
  PRESENCIAL_FORA_ESTABELECIMENTO = 5,
}

export namespace ETipoVendaNFe {
  export function toDisplay(arg: ETipoVendaNFe): string {
    switch (arg) {
      case 0: return "";
      case 1: return "Presencial";
      case 2: return "Internet";
      case 3: return "Outros";
      case 4: return "NFCe Delivery";
      case 5: return "Presencial fora do estabelecimento";
      default: return "";
    }
  }

  export function enums(): ETipoVendaNFe[] {
    return [ETipoVendaNFe.NONE,ETipoVendaNFe.PRESENCIAL,ETipoVendaNFe.INTERNET,ETipoVendaNFe.OUTROS,ETipoVendaNFe.NFC_DELIVERY,ETipoVendaNFe.PRESENCIAL_FORA_ESTABELECIMENTO];
  }
}


export class DataClienteMacleAPP extends BaseData {
  readonly jclass: string = "com.sollus.vo.DataClienteMacleAPP";
  codClienteMacle: number = 0;
  endereco: DataEndereco = new DataEndereco();
  fantasia: string = "";
  servidorConsulta: string = "";
}


export class DataListaClienteMacleAPP extends BaseData {
  readonly jclass: string = "com.sollus.vo.DataListaClienteMacleAPP";
  listCli: ArrayList<DataClienteMacleAPP> = new ArrayList<DataClienteMacleAPP>(DataClienteMacleAPP);
}


export abstract class PKable {
  readonly jclass: string = "com.sollus.vo.PKable";
}


export class PKLong extends BaseData {
  readonly jclass: string = "com.sollus.vo.PKLong";
  codigo: number = 0;

  constructor()
  constructor(codigo: number)
  constructor(codigo?: number) {
    super();
    this.codigo = codigo || 0;
  }

  public getPK(): PKLong {
    return new PKLong(this.codigo);
  }

  public equals(arg: PKLong): boolean {
    return arg 
        && (arg.codigo === this.codigo)
    ;
  }
}


export enum EAmbienteVitrine {
  NONE = 0,
  DEDICADO = 1,
  COMPARTILHADO = 2,
}

export namespace EAmbienteVitrine {
  export function toDisplay(arg: EAmbienteVitrine): string {
    switch (arg) {
      case 0: return "";
      case 1: return "Dedicado";
      case 2: return "Compartilhado";
      default: return "";
    }
  }

  export function enums(): EAmbienteVitrine[] {
    return [EAmbienteVitrine.NONE,EAmbienteVitrine.DEDICADO,EAmbienteVitrine.COMPARTILHADO];
  }
}


export enum EFilterBool {
  NONE = "''",
  SIM = "'S'",
  NAO = "'N'",
}

export namespace EFilterBool {
  export function toDisplay(arg: EFilterBool): string {
    switch (arg) {
      case "''": return "Todos";
      case "'S'": return "Sim";
      case "'N'": return "N&atilde;o";
      default: return "";
    }
  }

  export function enums(): EFilterBool[] {
    return [EFilterBool.NONE,EFilterBool.SIM,EFilterBool.NAO];
  }
}


export enum EGenero {
  NONE = 0,
  MASCULINO = 1,
  FEMININO = 2,
  UNISEX = 3,
}

export namespace EGenero {
  export function toDisplay(arg: EGenero): string {
    switch (arg) {
      case 0: return "";
      case 1: return "Masculino";
      case 2: return "Feminino";
      case 3: return "Unisex";
      default: return "";
    }
  }

  export function enums(): EGenero[] {
    return [EGenero.NONE,EGenero.MASCULINO,EGenero.FEMININO,EGenero.UNISEX];
  }
}


export class PK extends BaseData {
  readonly jclass: string = "com.sollus.vo.PK";
  codigo: number = 0;

  constructor()
  constructor(codigo: number)
  constructor(codigo?: number) {
    super();
    this.codigo = codigo || 0;
  }

  public getPK(): PK {
    return new PK(this.codigo);
  }

  public equals(arg: PK): boolean {
    return arg 
        && (arg.codigo === this.codigo)
    ;
  }
}


export class DataAmbiente extends BaseData {
  readonly jclass: string = "com.sollus.vo.DataAmbiente";
  nomeServidor: string = "";
  contexto: string = "";
  ipServidor: string = "";
  basePath: string = "";
  protocolo: string = "";
  porta: string = "";

  constructor()
  constructor(protocolo: string, ipServidor: string, nomeServidor: string, porta: string, contexto: string)
  constructor(protocolo?: string, ipServidor?: string, nomeServidor?: string, porta?: string, contexto?: string) {
    super();
    this.protocolo = protocolo || "";
    this.ipServidor = ipServidor || "";
    this.nomeServidor = nomeServidor || "";
    this.porta = porta || "";
    this.contexto = contexto || "";
  }

  public getPK(): DataAmbiente {
    return new DataAmbiente(this.protocolo, this.ipServidor, this.nomeServidor, this.porta, this.contexto);
  }

  public equals(arg: DataAmbiente): boolean {
    return arg 
        && (arg.nomeServidor === this.nomeServidor)
        && (arg.contexto === this.contexto)
        && (arg.ipServidor === this.ipServidor)
        && (arg.basePath === this.basePath)
        && (arg.protocolo === this.protocolo)
        && (arg.porta === this.porta)
    ;
  }
}


export enum EStatusTask {
  NONE = 0,
  RUNNING = 1,
  WAITING = 2,
  ERROR = 3,
}

export namespace EStatusTask {
  export function toDisplay(arg: EStatusTask): string {
    switch (arg) {
      case 0: return "";
      case 1: return "Correndo";
      case 2: return "Aguardando";
      case 3: return "Erro";
      default: return "";
    }
  }

  export function enums(): EStatusTask[] {
    return [EStatusTask.NONE,EStatusTask.RUNNING,EStatusTask.WAITING,EStatusTask.ERROR];
  }
}


export class DataRunnerInfo extends BaseData {
  readonly jclass: string = "com.sollus.model.runner.DataRunnerInfo";
  name: string = "";
  ID: number = 0;
  errMessage: string = "";
  status: EStatusTask = EStatusTask.NONE;

  constructor()
  constructor(ID: number, name: string, status: EStatusTask, errMessage: string)
  constructor(ID?: number, name?: string, status?: EStatusTask, errMessage?: string) {
    super();
    this.ID = ID || 0;
    this.name = name || "";
    this.status = status || EStatusTask.NONE;
    this.errMessage = errMessage || "";
  }

  public getPK(): DataRunnerInfo {
    return new DataRunnerInfo(this.ID, this.name, this.status, this.errMessage);
  }

  public equals(arg: DataRunnerInfo): boolean {
    return arg 
        && (arg.name === this.name)
        && (arg.ID === this.ID)
        && (arg.errMessage === this.errMessage)
        && (arg.status === this.status)
    ;
  }
}


export enum ETipoPessoa {
  NONE = "",
  FISICA = "F",
  JURIDICA = "J",
}

export namespace ETipoPessoa {
  export function toDisplay(arg: ETipoPessoa): string {
    switch (arg) {
      case "": return "";
      case "F": return "F&iacute;sica";
      case "J": return "Jur&iacute;dica";
      default: return "";
    }
  }

  export function enums(): ETipoPessoa[] {
    return [ETipoPessoa.NONE,ETipoPessoa.FISICA,ETipoPessoa.JURIDICA];
  }
}


export class DataLojaAPP extends BaseData {
  readonly jclass: string = "com.sollus.vo.DataLojaAPP";
  telefone: number = 0;
  logradouro: string = "";
  fantasia: string = "";
  bairro: string = "";
  cidade: string = "";
  cnpj: string = "";
  UF: string = "";
  numero: string = "";
  CEP: number = 0;
}


export class DataArquivo extends BaseData {
  readonly jclass: string = "com.sollus.vo.DataArquivo";
  path: string = "";
  nomeEmDisco: string = "";
  extensao: string = "";
  nome: string = "";

  constructor()
  constructor(nome: string, nomeEmDisco: string, extensao: string, path: string)
  constructor(nome?: string, nomeEmDisco?: string, extensao?: string, path?: string) {
    super();
    this.nome = nome || "";
    this.nomeEmDisco = nomeEmDisco || "";
    this.extensao = extensao || "";
    this.path = path || "";
  }

  public getPK(): DataArquivo {
    return new DataArquivo(this.nome, this.nomeEmDisco, this.extensao, this.path);
  }

  public equals(arg: DataArquivo): boolean {
    return arg 
        && (arg.path === this.path)
        && (arg.nomeEmDisco === this.nomeEmDisco)
        && (arg.extensao === this.extensao)
        && (arg.nome === this.nome)
    ;
  }
}


export class PKFuncionario extends BaseData {
  readonly jclass: string = "com.sollus.vo.PKFuncionario";
  codFuncionario: number = 0;
  codEmpresa: number = 0;

  constructor()
  constructor(codEmpresa: number, codFuncionario: number)
  constructor(codEmpresa?: number, codFuncionario?: number) {
    super();
    this.codEmpresa = codEmpresa || 0;
    this.codFuncionario = codFuncionario || 0;
  }

  public getPK(): PKFuncionario {
    return new PKFuncionario(this.codEmpresa, this.codFuncionario);
  }

  public equals(arg: PKFuncionario): boolean {
    return arg 
        && (arg.codFuncionario === this.codFuncionario)
        && (arg.codEmpresa === this.codEmpresa)
    ;
  }
}


export class DataLOG extends BaseData {
  readonly jclass: string = "com.sollus.vo.DataLOG";
  base: number = 0;
  data: string = "";
  replicado: boolean = false;
  acao: number = 0;
  entidade: number = 0;
  usuario: PKFuncionario = new PKFuncionario();
  PKLog: string = "";
  codLOG: number = 0;
  hora: string = "";
  request: number = 0;

  public getPK(): PKLong {
    let result: PKLong =  new PKLong();
    result.codigo = this.codLOG;
    return result;
  }

  public equals(arg: PKLong): boolean {
    return arg 
        && (arg.codigo === this.codLOG)
    ;
  }
}


export class JsonObject {
  readonly jclass: string = "com.sollus.json.JsonObject";
}


export enum ETipoLicenca {
  NONE = 0,
  FULL = 1,
  LIGHT = 2,
  TRIAL = 3,
}

export namespace ETipoLicenca {
  export function toDisplay(arg: ETipoLicenca): string {
    switch (arg) {
      case 0: return "Informe";
      case 1: return "Controle FULL";
      case 2: return "Controle LIGHT";
      case 3: return "Trial";
      default: return "";
    }
  }

  export function enums(): ETipoLicenca[] {
    return [ETipoLicenca.NONE,ETipoLicenca.FULL,ETipoLicenca.LIGHT,ETipoLicenca.TRIAL];
  }
}


export class PKStr extends BaseData {
  readonly jclass: string = "com.sollus.vo.PKStr";
  codigo: string = "";

  constructor()
  constructor(codigo: string)
  constructor(codigo?: string) {
    super();
    this.codigo = codigo || "";
  }

  public getPK(): PKStr {
    return new PKStr(this.codigo);
  }

  public equals(arg: PKStr): boolean {
    return arg 
        && (arg.codigo === this.codigo)
    ;
  }
}


export class DataPageContext extends BaseData {
  readonly jclass: string = "com.sollus.vo.DataPageContext";
}


export class DataCEP extends BaseData {
  readonly jclass: string = "com.sollus.vo.DataCEP";
  logradouro: string = "";
  codIbgeMun: string = "";
  bairro: string = "";
  cidade: string = "";
  codCEP: number = 0;
  codUF: string = "";

  public getPK(): PK {
    let result: PK =  new PK();
    result.codigo = this.codCEP;
    return result;
  }

  public equals(arg: PK): boolean {
    return arg 
        && (arg.codigo === this.codCEP)
    ;
  }
}


export class DataServiceResponse extends BaseData {
  readonly jclass: string = "com.sollus.vo.DataServiceResponse";
  mensagem: string = "";
  pk: BaseData | undefined = undefined;
}


export class FilterLOG extends BaseData {
  readonly jclass: string = "com.sollus.vo.FilterLOG";
  acao: number = 0;
  entidade: number = 0;
  usuario: PKFuncionario = new PKFuncionario();
  repl: EFilterBool = EFilterBool.NONE;
  dataIni: string = "";
  dataFim: string = "";
}


export enum EIndSincNFe {
  ASSINCRONO = 0,
  SINCRONO = 1,
}

export namespace EIndSincNFe {
  export function toDisplay(arg: EIndSincNFe): string {
    switch (arg) {
      case 0: return "Assincrono";
      case 1: return "Sincrono";
      default: return "";
    }
  }

  export function enums(): EIndSincNFe[] {
    return [EIndSincNFe.ASSINCRONO,EIndSincNFe.SINCRONO];
  }
}


export enum EPlanoVersaoLight {
  NONE = 0,
  AUTONOMO = 1,
  BASICO = 2,
  IDEAL = 3,
}

export namespace EPlanoVersaoLight {
  export function toDisplay(arg: EPlanoVersaoLight): string {
    switch (arg) {
      case 0: return "";
      case 1: return "Autonomo";
      case 2: return "Basico";
      case 3: return "Ideal";
      default: return "";
    }
  }

  export function enums(): EPlanoVersaoLight[] {
    return [EPlanoVersaoLight.NONE,EPlanoVersaoLight.AUTONOMO,EPlanoVersaoLight.BASICO,EPlanoVersaoLight.IDEAL];
  }
}


export class DataErrorResp extends DataServiceResponse {
  readonly jclass: string = "com.sollus.vo.DataErrorResp";
  stackTrace: string[] = [];
  errorClass: string = "";
  codigo: number = 0;
}


export class BaseDataLogin extends BaseData {
  readonly jclass: string = "com.sollus.vo.BaseDataLogin";
  codUsuario: BaseData | undefined = undefined;
  codEmpresa: number = 0;
  dataRef: string = "";
  tfa: boolean = false;
  tfaCode: number = 0;
}


export enum ETipoFone {
  NONE = 0,
  CELULAR = 1,
  CASA = 2,
  TRABALHO = 3,
  OUTRO = 99,
  ESTRANGEIRO = 100,
}

export namespace ETipoFone {
  export function toDisplay(arg: ETipoFone): string {
    switch (arg) {
      case 0: return "";
      case 1: return "Celular";
      case 2: return "Casa";
      case 3: return "Trabalho";
      case 99: return "Outros";
      case 100: return "Estrangeiro";
      default: return "";
    }
  }

  export function enums(): ETipoFone[] {
    return [ETipoFone.NONE,ETipoFone.CELULAR,ETipoFone.CASA,ETipoFone.TRABALHO,ETipoFone.OUTRO,ETipoFone.ESTRANGEIRO];
  }
}


export enum ERegimeTributario {
  NONE = 0,
  NORMAL = 3,
  LUCRO_PRESUMIDO = 5,
  SIMPLES_NACIONAL = 1,
}

export namespace ERegimeTributario {
  export function toDisplay(arg: ERegimeTributario): string {
    switch (arg) {
      case 0: return "-- Informe --";
      case 3: return "Lucro Real";
      case 5: return "Lucro Presumido";
      case 1: return "Simples Nacional";
      default: return "";
    }
  }

  export function enums(): ERegimeTributario[] {
    return [ERegimeTributario.NONE,ERegimeTributario.NORMAL,ERegimeTributario.LUCRO_PRESUMIDO,ERegimeTributario.SIMPLES_NACIONAL];
  }
}


export enum ETipoVitrine {
  NONE = 0,
  PRIVADA = 1,
  PUBLICA = 2,
}

export namespace ETipoVitrine {
  export function toDisplay(arg: ETipoVitrine): string {
    switch (arg) {
      case 0: return "";
      case 1: return "Privada";
      case 2: return "P&uacute;blica";
      default: return "";
    }
  }

  export function enums(): ETipoVitrine[] {
    return [ETipoVitrine.NONE,ETipoVitrine.PRIVADA,ETipoVitrine.PUBLICA];
  }
}


export enum EUF {
  NONE = 0,
  AC = 1,
  AL = 2,
  AM = 3,
  AP = 4,
  BA = 5,
  CE = 6,
  DF = 7,
  ES = 8,
  GO = 9,
  MA = 10,
  MG = 11,
  MS = 12,
  MT = 13,
  PA = 14,
  PB = 15,
  PE = 16,
  PI = 17,
  PR = 18,
  RJ = 19,
  RN = 20,
  RO = 21,
  RR = 22,
  RS = 23,
  SC = 24,
  SE = 25,
  SP = 26,
  TO = 27,
}

export namespace EUF {
  export function toDisplay(arg: EUF): string {
    switch (arg) {
      case 0: return "";
      case 1: return "AC - Acre";
      case 2: return "AL - Alagoas";
      case 3: return "AM - Amazonas";
      case 4: return "AP - Amap&aacute;";
      case 5: return "BA - Bahia";
      case 6: return "CE - Cear&aacute;";
      case 7: return "DF - Distrito Federal";
      case 8: return "ES - Esp&iacute;rito Santo";
      case 9: return "GO - Goi&aacute;s";
      case 10: return "MA - Maranh&atilde;o";
      case 11: return "MG - Minas Gerais";
      case 12: return "MS - Mato Grosso do Sul";
      case 13: return "MT - Mato Grosso";
      case 14: return "PA - Par&aacute;";
      case 15: return "PB - Para&iacute;ba";
      case 16: return "PE - Pernanbuco";
      case 17: return "PI - Piau&iacute;";
      case 18: return "PR - Paran&aacute;";
      case 19: return "RJ - Rio de Janeiro";
      case 20: return "RN - Rio Grande do Norte";
      case 21: return "RO - Rondônia";
      case 22: return "RR - Roraima";
      case 23: return "RS - Rio Grande do Sul";
      case 24: return "SC - Santa Catarina";
      case 25: return "SE - Sergipe";
      case 26: return "SP - S&atilde;o Paulo";
      case 27: return "TO - Tocantins";
      default: return "";
    }
  }

  export function enums(): EUF[] {
    return [EUF.NONE,EUF.AC,EUF.AL,EUF.AM,EUF.AP,EUF.BA,EUF.CE,EUF.DF,EUF.ES,EUF.GO,EUF.MA,EUF.MG,EUF.MS,EUF.MT,EUF.PA,EUF.PB,EUF.PE,EUF.PI,EUF.PR,EUF.RJ,EUF.RN,EUF.RO,EUF.RR,EUF.RS,EUF.SC,EUF.SE,EUF.SP,EUF.TO];
  }
}


export enum EStatusPedidoSite {
  NONE = 0,
  PRECONFPAGTO = 7,
  CONFERENCIAPAGTO = 1,
  EMANALISE = 10,
  APROVADO = 6,
  REPROVADO = 8,
  PRONTO_RETIRA = 13,
  EXPEDICAO = 2,
  EMBARQUE = 3,
  ENTREGUE = 4,
  CANCELADO = 5,
  DEVOLUCAO = 9,
  CONTESTADO = 11,
  NAOFINALIZADO = 12,
}

export namespace EStatusPedidoSite {
  export function toDisplay(arg: EStatusPedidoSite): string {
    switch (arg) {
      case 0: return "";
      case 7: return "Pre confirmacao";
      case 1: return "Conf. pagto";
      case 10: return "Em analise";
      case 6: return "Aprovado";
      case 8: return "Reprovado";
      case 13: return "Pronto Retirar";
      case 2: return "Expedicao";
      case 3: return "Embarque";
      case 4: return "Entregue";
      case 5: return "Cancelado";
      case 9: return "Devolucao";
      case 11: return "Contestado";
      case 12: return "Pedido nao Finalizado";
      default: return "";
    }
  }

  export function enums(): EStatusPedidoSite[] {
    return [EStatusPedidoSite.NONE,EStatusPedidoSite.PRECONFPAGTO,EStatusPedidoSite.CONFERENCIAPAGTO,EStatusPedidoSite.EMANALISE,EStatusPedidoSite.APROVADO,EStatusPedidoSite.REPROVADO,EStatusPedidoSite.PRONTO_RETIRA,EStatusPedidoSite.EXPEDICAO,EStatusPedidoSite.EMBARQUE,EStatusPedidoSite.ENTREGUE,EStatusPedidoSite.CANCELADO,EStatusPedidoSite.DEVOLUCAO,EStatusPedidoSite.CONTESTADO,EStatusPedidoSite.NAOFINALIZADO];
  }
}


export enum ETipoContaBancaria {
  NONE = 0,
  CONTA_CORRENTE = 1,
  CONTA_POUPANCA = 2,
}

export namespace ETipoContaBancaria {
  export function toDisplay(arg: ETipoContaBancaria): string {
    switch (arg) {
      case 0: return "";
      case 1: return "Conta Corrente";
      case 2: return "Conta Poupan&ccedil;a";
      default: return "";
    }
  }

  export function enums(): ETipoContaBancaria[] {
    return [ETipoContaBancaria.NONE,ETipoContaBancaria.CONTA_CORRENTE,ETipoContaBancaria.CONTA_POUPANCA];
  }
}


export enum ETipoPeriodo {
  NONE = 0,
  ANTERIOR = 1,
  COMPLETO = 2,
  POSTERIOR = 3,
}

export namespace ETipoPeriodo {
  export function toDisplay(arg: ETipoPeriodo): string {
    switch (arg) {
      case 0: return "Personalizado";
      case 1: return "Anterior";
      case 2: return "Completo";
      case 3: return "Posterior";
      default: return "";
    }
  }

  export function enums(): ETipoPeriodo[] {
    return [ETipoPeriodo.NONE,ETipoPeriodo.ANTERIOR,ETipoPeriodo.COMPLETO,ETipoPeriodo.POSTERIOR];
  }
}


export class DataListaLojaAPP extends BaseData {
  readonly jclass: string = "com.sollus.vo.DataListaLojaAPP";
  listLoja: ArrayList<DataLojaAPP> = new ArrayList<DataLojaAPP>(DataLojaAPP);
}


export class PKFuncionarioGerencia extends PKFuncionario {
  readonly jclass: string = "com.sollus.vo.PKFuncionarioGerencia";
  codEmpresaGerencia: number = 0;

  constructor()
  constructor(codEmpresa: number, codFuncionario: number, codEmpresaGerencia: number)
  constructor(codEmpresa?: number, codFuncionario?: number, codEmpresaGerencia?: number) {
    super();
    this.codEmpresa = codEmpresa || 0;
    this.codFuncionario = codFuncionario || 0;
    this.codEmpresaGerencia = codEmpresaGerencia || 0;
  }

  public getPK(): PKFuncionarioGerencia {
    return new PKFuncionarioGerencia(this.codEmpresa, this.codFuncionario, this.codEmpresaGerencia);
  }

  public equals(arg: PKFuncionarioGerencia): boolean {
    return arg && super.equals(arg)
        && (arg.codEmpresaGerencia === this.codEmpresaGerencia)
    ;
  }
}


export enum ETipoFrete {
  NONE = 0,
  SEDEX = 1,
  PAC = 2,
  ENVIO_FLEX_ML = 3,
  TRANSPORTADORA = 4,
}

export namespace ETipoFrete {
  export function toDisplay(arg: ETipoFrete): string {
    switch (arg) {
      case 0: return "";
      case 1: return "Sedex";
      case 2: return "Encomenda PAC";
      case 3: return "Envio Flex";
      case 4: return "Transporadora";
      default: return "";
    }
  }

  export function enums(): ETipoFrete[] {
    return [ETipoFrete.NONE,ETipoFrete.SEDEX,ETipoFrete.PAC,ETipoFrete.ENVIO_FLEX_ML,ETipoFrete.TRANSPORTADORA];
  }
}


export enum EPeriodo {
  HOJE = 0,
  ONTEM = 4,
  AMANHA = 10,
  SEMANA_ATUAL = 1,
  SEMANA_ANTERIOR = 5,
  SEMANA_PROXIMA = 11,
  MES_ATUAL = 2,
  MES_ANTERIOR = 6,
  MES_PROXIMO = 12,
  ULTIMOS_TRES_MESES = 8,
  ULTIMOS_DOZE_MESES = 18,
  PROXIMOS_TRES_MESES = 13,
  SEMESTRE_ATUAL = 14,
  SEMESTRE_ANTERIOR = 15,
  SEMESTRE_PROXIMO = 16,
  ANO_ATUAL = 3,
  ANO_ANTERIOR = 7,
  ANO_PROXIMO = 17,
  PERSONALIZADO = 9,
}

export namespace EPeriodo {
  export function toDisplay(arg: EPeriodo): string {
    switch (arg) {
      case 0: return "Hoje";
      case 4: return "Ontem";
      case 10: return "Amanh&amp;atilde;";
      case 1: return "Semana atual";
      case 5: return "Semana anterior";
      case 11: return "Pr&amp;oacute;xima semana";
      case 2: return "M&amp;ecirc;s atual";
      case 6: return "M&amp;ecirc;s anterior";
      case 12: return "Pr&amp;oacute;ximo m&amp;ecirc;s";
      case 8: return "&amp;Uacute;ltimos tr&amp;ecirc;s meses";
      case 18: return "&amp;Uacute;ltimos doze meses";
      case 13: return "Pr&amp;oacute;ximos tr&amp;ecirc;s meses";
      case 14: return "Semestre atual";
      case 15: return "Semestre anterior";
      case 16: return "Pr&amp;oacute;ximo semestre";
      case 3: return "Ano atual";
      case 7: return "Ano anterior";
      case 17: return "Pr&amp;oacute;ximo ano";
      case 9: return "Personalizado";
      default: return "";
    }
  }

  export function enums(): EPeriodo[] {
    return [EPeriodo.HOJE,EPeriodo.ONTEM,EPeriodo.AMANHA,EPeriodo.SEMANA_ATUAL,EPeriodo.SEMANA_ANTERIOR,EPeriodo.SEMANA_PROXIMA,EPeriodo.MES_ATUAL,EPeriodo.MES_ANTERIOR,EPeriodo.MES_PROXIMO,EPeriodo.ULTIMOS_TRES_MESES,EPeriodo.ULTIMOS_DOZE_MESES,EPeriodo.PROXIMOS_TRES_MESES,EPeriodo.SEMESTRE_ATUAL,EPeriodo.SEMESTRE_ANTERIOR,EPeriodo.SEMESTRE_PROXIMO,EPeriodo.ANO_ATUAL,EPeriodo.ANO_ANTERIOR,EPeriodo.ANO_PROXIMO,EPeriodo.PERSONALIZADO];
  }
}


export class PeriodoMes extends BaseData {
  readonly jclass: string = "com.sollus.vo.PeriodoMes";
  meses: number = 0;
}


